import { GetStaticProps } from 'next';
import Link from 'next/link';
import { getSortedPostsData, Post } from '@/lib/posts';
import DefaultLayout from '@/components/DefaultLayout';

interface BlogPageProps {
  allPostsData: Post[];
}

export default function BlogPage({ allPostsData }: BlogPageProps) {
  return (
    <DefaultLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <h1 className="text-3xl sm:text-4xl font-bold mb-8">Blog Posts</h1>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {allPostsData.map(({ id, title, date, excerpt, tags }) => (
            <Link
              key={id}
              href={`/blog/${id}`}
              className="bg-gray-100 dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-[0_0_30px_rgba(128,128,128,0.3)] dark:hover:shadow-[0_0_30px_rgba(255,255,255,0.2)] hover:scale-[1.02] transition-all duration-300"
            >
              <div className="p-6">
                <h2 className="text-xl font-bold mb-2">{title}</h2>
                <div className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                  {new Date(date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </div>
                <p className="text-gray-600 dark:text-gray-300 mb-4">{excerpt}</p>
                {tags && (
                  <div className="flex flex-wrap gap-2">
                    {tags.map(tag => (
                      <span
                        key={tag}
                        className="px-3 py-1 bg-black/[.05] dark:bg-white/[.06] rounded-full text-sm"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </DefaultLayout>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const allPostsData = getSortedPostsData();
  return {
    props: {
      allPostsData,
    },
  };
}; 